/*
 * This file is picked up by the build system only
 * when building for PRODUCTION
 */

import { Notify } from 'quasar'
import i18n from 'src/i18n/i18n'
import { register } from 'register-service-worker'

register(process.env.SERVICE_WORKER_FILE, {
  ready () {
    console.log('App is being served from cache by a service worker.')
  },
  registered (registration) { // registration -> a ServiceWorkerRegistration instance
    console.log('Service worker has been registered.')
  },
  cached (registration) { // registration -> a ServiceWorkerRegistration instance
    console.log('Content has been cached for offline use.')
  },
  updatefound (registration) { // registration -> a ServiceWorkerRegistration instance
    console.log('New content is downloading.')
  },
  updated (registration) { // registration -> a ServiceWorkerRegistration instance
    console.log('New content is available; please refresh.')
    registration.waiting.postMessage({ action: 'skipWaiting' })

    Notify.create({
      message: i18n.t('new_version'),
      timeout: 0,
      color: 'grey',
      actions: [{
        label: i18n.t('reload'),
        handler: () => {
          window.location.reload()
        }
      }]
    })
  },
  offline () {
    console.log('No internet connection found. App is running in offline mode.')
  },
  error (err) {
    console.error('Error during service worker registration:', err)
  }
})

// ServiceWorkerRegistration: https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerRegistration
